import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface RecruitRequest {
    category: string;
    limit: string;
    page: number;
    // search: "subject" | "contents";
    search: string;
    searchtxt: string;
}
export type DataListProps = {
    list_no: number;
    m_name: string;
    m_age: string;
    m_tel: string;
    m_area: string;
    m_car: string;
    m_up: string;
    m_time: string;
    contents: string;
    w_date: string;
};

export interface RecruitResponseData {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetConsoleRecruitStatus = ({
    category,
    search,
    searchtxt,
    page,
    limit,
}: RecruitRequest): UseQueryResult<RecruitResponseData, Error> => {
    let url = enum_api_uri.get_console_recruit_status.replace(":category", category);
    return useQuery({
        queryKey: ["useGetConsoleRecruitStatus", category, search, searchtxt, page, limit],
        queryFn: async () => {
            const response = await axiosInstance.get(url, {
                params: {
                    search,
                    searchtxt,
                    page,
                    limit,
                },
            });
            return response.data.data;
        },
    });
};
